export default __webpack_public_path__ + "static/media/effect-32.f2b5a61c.mp3";